<div
  class="smart-table"
  [class.header-single-line]="headerSingleLine"
  [class.compact-table]="compactTable"
  [class.fit-to-container]="fitToContainer"
  [class.nowrap-data]="nowrapData"
>
  <div class="table-shell">
    <div class="table-state" *ngIf="loading">Loading table...</div>
    <div class="table-state error" *ngIf="!loading && errorMessage">{{ errorMessage }}</div>
    <div class="table-state" *ngIf="!loading && !errorMessage && rows.length === 0">{{ emptyStateMessage }}</div>

    <ng-container *ngIf="!loading && !errorMessage && rows.length > 0">
      <ng-container
        *ngTemplateOutlet="tableTemplate; context: {
          columns: columns,
          rows: rows,
          tableHeight: tableHeight,
          emptyMessage: emptyStateMessage,
          scope: 'main'
        }"
      ></ng-container>

      <div class="table-footer">
        <div class="table-feedback">
          <!-- <span class="sync-message" *ngIf="syncMessage">{{ syncMessage }}</span> -->
          <span class="submit-message success" *ngIf="submitMessage">{{ submitMessage }}</span>
          <span class="submit-message error" *ngIf="submitErrorMessage">{{ submitErrorMessage }}</span>
        </div>

        <div class="table-actions" [ngClass]="submitButtonAlignClass" *ngIf="mainHeaderActions.length || hasSubmitAction">
          <button
            *ngFor="let action of mainHeaderActions"
            class="submit-button"
            type="button"
            (click)="onMainActionClick(action)"
          >
            {{ action.label }}
          </button>
          <button *ngIf="hasSubmitAction" class="submit-button" type="button" [disabled]="submitInFlight" (click)="submitTable()">
            {{ submitInFlight ? 'Submitting...' : submitButtonLabel }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template
  #tableTemplate
  let-columns="columns"
  let-rows="rows"
  let-tableHeight="tableHeight"
  let-emptyMessage="emptyMessage"
  let-scope="scope"
>
  <div
    class="table-scroll"
    [class.inline-table-scroll]="scope === 'inline'"
    [class.popup-table-scroll]="scope === 'popup'"
    [class.main-scroll-with-inline-detail]="scope === 'main' && !!inlineDetailRowId"
    [style.height]="tableHeight"
    [style.max-height]="tableHeight"
  >
    <table class="smart-table-grid" [style.min-width]="getTableMinWidth(columns)">
      <colgroup>
        <col *ngFor="let column of columns; trackBy: trackByColumn" [style.width]="getColumnWidth(column)" />
      </colgroup>
      <thead>
        <tr>
          <th
            *ngFor="let column of columns; trackBy: trackByColumn"
            [ngClass]="getHeaderClasses(column, scope)"
            [style.width]="getColumnWidth(column)"
            [attr.data-column-key]="column.bindingKey || column.key"
            [attr.title]="getColumnTooltip(column) || null"
          >
            <span class="header-label-text">{{ getHeaderLabel(column, scope) }}</span>
            <button
              *ngIf="showHeaderEditIndicator(column)"
              class="header-edit-indicator-btn"
              [class.active]="isHeaderEditColumnActive(scope, column)"
              type="button"
              [attr.title]="isHeaderEditColumnActive(scope, column) ? 'Stop editing this column' : 'Edit this column'"
              (click)="toggleHeaderEditColumn(scope, column, $event)"
            >
              <svg
                class="header-edit-indicator"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
              </svg>
            </button>
            <button
              *ngIf="showInlineHeaderEditToggle(scope, column)"
              class="header-edit-toggle"
              [class.active]="isInlineHeaderEditToggleActive(column)"
              type="button"
              [attr.title]="getColumnTooltip(column) || (isInlineHeaderEditToggleActive(column) ? 'Done editing' : 'Edit this column')"
              [attr.aria-pressed]="isInlineHeaderEditToggleActive(column)"
              (click)="toggleInlineDetailEditMode(column)"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
              </svg>
            </button>
          </th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let row of rows; let rowIndex = index; trackBy: trackByRow">
          <tr
            [ngClass]="getRowClasses(scope, row, rowIndex)"
            (click)="onRowClick(scope, row, rowIndex, $event)"
          >
            <td *ngFor="let column of columns; trackBy: trackByColumn" [ngClass]="getCellClasses(column, scope)" [attr.data-column-key]="column.bindingKey || column.key">
              <ng-container *ngIf="isSliderColumn(column); else standardCell">
                <ng-container *ngIf="isReadonlySlider(column); else editableSliderCell">
                  <div class="slider-static">
                    <div class="slider-static-track">
                      <span class="slider-static-fill" [style.width.%]="getSliderPercent(row, column)"></span>
                    </div>
                    <span class="slider-static-value">{{ getSliderLabel(row, column) }}</span>
                  </div>
                </ng-container>

                <ng-template #editableSliderCell>
                  <div class="slider-cell">
                    <div class="slider-metadata">
                      <span class="slider-current">{{ getSliderLabel(row, column) }}</span>
                      <span class="slider-range">
                        {{ getSliderMin(row, column) }} - {{ getSliderMax(row, column) }}
                      </span>
                    </div>
                    <input
                      class="slider-input"
                      [class.slider-input--readonly]="!userInputEnabled"
                      type="range"
                      [min]="getSliderMin(row, column)"
                      [max]="getSliderMax(row, column)"
                      [step]="getSliderStep(row, column)"
                      [value]="getSliderPosition(row, column)"
                      [attr.tabindex]="!userInputEnabled ? -1 : null"
                      [attr.aria-disabled]="!userInputEnabled"
                      (input)="onSliderChange(scope, rowIndex, row, column, $event)"
                      (change)="onSliderCommit(scope, rowIndex, row, column)"
                    />
                  </div>
                </ng-template>
              </ng-container>

              <ng-template #standardCell>
                <ng-container *ngIf="isProgressColumn(column); else nonProgressCell">
                  <div class="progress-cell">
                    <div class="progress-track">
                      <span
                        class="progress-fill"
                        [style.width.%]="getProgressPercent(row, column)"
                        [style.background]="getProgressColor(row, column)"
                      ></span>
                    </div>
                    <span class="progress-label">{{ getProgressLabel(row, column) }}</span>
                  </div>
                </ng-container>

                <ng-template #nonProgressCell>
                  <ng-container *ngIf="isStatusColumn(column); else nonStatusCell">
                    <span class="status-pill" [style.background]="getStatusColor(row, column)">
                      {{ getStatusLabel(row, column) }}
                    </span>
                  </ng-container>

                  <ng-template #nonStatusCell>
                    <ng-container *ngIf="isDropdownColumn(column); else nonDropdownCell">
                      <div class="dropdown-cell">
                        <select
                          class="cell-select"
                          [class.cell-select--readonly]="!userInputEnabled"
                          [value]="getDropdownValue(row, column)"
                          [attr.tabindex]="!userInputEnabled ? -1 : null"
                          [attr.aria-disabled]="!userInputEnabled"
                          (focus)="onDropdownFocus(rowIndex, row, column)"
                          (change)="onDropdownChange(scope, rowIndex, row, column, $event)"
                          (keydown.enter)="onDropdownCommit(scope, rowIndex, row, column, $event)"
                        >
                          <option *ngIf="getDropdownValue(row, column) === ''" [selected]="true" value="">{{ column.dropdownPlaceholder || 'Select' }}</option>
                          <option
                            *ngFor="let option of getDropdownOptions(rowIndex, row, column)"
                            [value]="option.value"
                            [disabled]="option.disabled"
                            [selected]="option.value == getDropdownValue(row, column)"
                          >
                            {{ option.label }}
                          </option>
                        </select>
                        <span class="dropdown-loading" *ngIf="isDropdownLoading(rowIndex, row, column)">Loading...</span>
                      </div>
                    </ng-container>

                    <ng-template #nonDropdownCell>
                      <ng-container *ngIf="isActionColumn(column); else popupOrEditableCell">
                        <span
                          class="cell-action-wrapper"
                          (mouseenter)="onCellMouseEnter(scope, rowIndex, row, column, $event)"
                          (mouseleave)="onCellMouseLeave(scope, rowIndex, row, column)"
                        >
                          <button
                            class="cell-action"
                            [class.icon-only]="column.actionVariant === 'icon'"
                            type="button"
                            [attr.title]="hasHoverPopover(column) ? null : (getActionTooltip(row, column) || null)"
                            [attr.aria-label]="getActionTooltip(row, column) || null"
                            (click)="onActionClick(scope, row, column, rowIndex, $event)"
                          >
                            <span [innerHTML]="getActionLabel(row, column)"></span>
                          </button>
                          <div
                            class="cell-hover-popover"
                            [class.cell-hover-popover--comment]="(column.bindingKey || column.key) === 'comment'"
                            *ngIf="isHoverPopoverActive(scope, rowIndex, row, column) && !hasHistoryPopover(column)"
                            [style.top.px]="hoverPopoverPosition?.top"
                            [style.left.px]="hoverPopoverPosition?.left"
                            [style.right.px]="hoverPopoverPosition?.right"
                            [style.max-height.px]="hoverPopoverMaxHeight"
                            role="tooltip"
                          >
                            {{ getHoverPopoverContent(row, column) }}
                          </div>

                          <div
                            class="cell-hover-popover cell-history-popover"
                            [style.max-width.px]="hoverPopoverMaxWidth"
                            *ngIf="isHoverPopoverActive(scope, rowIndex, row, column) && hasHistoryPopover(column)"
                            [style.top.px]="hoverPopoverPosition?.top"
                            [style.left.px]="hoverPopoverPosition?.left"
                            [style.right.px]="hoverPopoverPosition?.right"
                            [style.max-height.px]="hoverPopoverMaxHeight"
                            role="tooltip"
                          >
                            <div class="history-popover-header">
                              <span class="material-icons history-popover-icon">history</span>
                              <span class="history-popover-title">{{ getHistoryPopoverTitle(row, column) }}</span>
                              <button type="button" class="history-popover-close" (click)="closeHoverPopover()" aria-label="Close history">
                                <span class="material-icons">close</span>
                              </button>
                            </div>

                            <ng-container *ngIf="getHistoryPopover(scope, rowIndex, row, column) as historyPopover; else historyPendingState">
                              <div class="history-popover-meta">
                                <div class="history-popover-meta-item">
                                  <span class="history-popover-meta-label">Customer ID:</span>
                                  <span class="history-popover-meta-value">{{ historyPopover.customerId }}</span>
                                </div>
                                <div class="history-popover-meta-item">
                                  <span class="history-popover-meta-label">Updated By:</span>
                                  <span class="history-popover-meta-value">{{ historyPopover.updatedBy }}</span>
                                </div>
                                <div class="history-popover-meta-item history-popover-meta-item--full">
                                  <span class="history-popover-meta-label">Latest Updated Date:</span>
                                  <span class="history-popover-meta-value">{{ formatHistoryDate(historyPopover.updatedDate) }}</span>
                                </div>
                              </div>

                              <div class="history-popover-section-title">
                                <span class="material-icons">list_alt</span>
                                Changed History
                              </div>

                              <div class="history-popover-versions">
                                <div class="history-version-card" *ngFor="let version of historyPopover.versions">
                                  <div class="history-version-header" (click)="toggleHistoryVersion(column, version, $event)">
                                    <span class="history-version-meta">Updated By: <strong>{{ version.updatedBy }}</strong></span>
                                    <span class="history-version-meta">Updated Date: <strong>{{ formatHistoryDate(version.updatedDate) }}</strong></span>
                                    <span class="history-changes-badge">Changes ({{ version.changes.length }})</span>
                                    <span class="material-icons history-version-toggle">{{ isHistoryVersionExpanded(column, version) ? 'expand_less' : 'expand_more' }}</span>
                                  </div>
                                  <div class="history-version-body" *ngIf="isHistoryVersionExpanded(column, version)">
                                    <table class="history-changes-table">
                                      <thead>
                                        <tr>
                                          <th *ngIf="version.changes[0]?.updatedBy !== undefined">Updated By</th>
                                          <th *ngIf="version.changes[0]?.updatedBy !== undefined">Updated Date</th>
                                          <th>Changed Field</th>
                                          <th>Previous Value</th>
                                          <th>New Value</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let change of version.changes">
                                          <td *ngIf="change.updatedBy !== undefined">{{ change.updatedBy }}</td>
                                          <td class="history-cell-date" *ngIf="change.updatedDate !== undefined">{{ formatHistoryDate(change.updatedDate) }}</td>
                                          <td>{{ change.field }}</td>
                                          <td class="history-value-previous">{{ change.previousValue }}</td>
                                          <td class="history-value-new">{{ change.newValue }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>

                              <div class="history-popover-legend">
                                <span class="history-legend-dot history-legend-dot--previous"></span>
                                <span>Previous Value</span>
                                <span class="material-icons history-legend-arrow">arrow_forward</span>
                                <span class="history-legend-dot history-legend-dot--new"></span>
                                <span>New Value</span>
                              </div>
                            </ng-container>

                            <ng-template #historyPendingState>
                              <div class="history-popover-state">
                                {{ isHistoryPopoverLoading(scope, rowIndex, row, column) ? 'Loading history...' : 'No history available.' }}
                              </div>
                            </ng-template>
                          </div>
                        </span>
                      </ng-container>

                      <ng-template #popupOrEditableCell>
                        <ng-container *ngIf="isPopupTriggerColumn(column); else editableOrDisplayCell">
                          <button class="cell-action cell-action-link" type="button" [attr.title]="getActionTooltip(row, column) || null" (click)="openPopup(row, column, rowIndex, $event)">
                            <span [innerHTML]="getActionLabel(row, column)"></span>
                          </button>
                        </ng-container>

                        <ng-template #editableOrDisplayCell>
                          <input
                            *ngIf="shouldRenderEditableInput(scope, rowIndex, row, column); else displayCell"
                            class="cell-input"
                            type="text"
                            [attr.inputmode]="isNumberLikeColumn(column) ? 'decimal' : null"
                            [placeholder]="column.placeholder || ''"
                            [value]="getInputValue(row, column)"
                            [attr.title]="getColumnTooltip(column) || null"
                            [readonly]="!userInputEnabled"
                            [class.cell-input--readonly]="!userInputEnabled"
                            [attr.tabindex]="!userInputEnabled ? -1 : null"
                            (input)="onInputChange(scope, rowIndex, row, column, $event)"
                            (change)="onInputCommit(scope, rowIndex, row, column, $event, 'change')"
                            (keydown.enter)="onInputCommit(scope, rowIndex, row, column, $event, 'enter')"
                          />

                          <ng-template #displayCell>
                            <span
                              *ngIf="isClickToEditColumn(column) && isHeaderEditColumnActive(scope, column); else clickToEditOrOtherDisplay"
                              class="cell-value cell-value-boxed"
                              [class.cell-value-boxed--placeholder]="isClickToEditValueEmpty(row, column)"
                              [attr.title]="(column.bindingKey || column.key) === 'comment' ? null : (hasHoverPopover(column) ? null : (getColumnTooltip(column) || getClickToEditDisplayValue(row, column) || null))"
                              (mouseenter)="onCellMouseEnter(scope, rowIndex, row, column, $event)"
                              (mouseleave)="onCellMouseLeave(scope, rowIndex, row, column)"
                            >
                              {{ getClickToEditDisplayValue(row, column) }}
                            </span>

                            <ng-template #clickToEditOrOtherDisplay>
                            <button
                              *ngIf="isClickToEditColumn(column); else navigableOrPlainDisplay"
                              class="cell-action cell-action-link cell-value-link"
                              type="button"
                              [attr.title]="(column.bindingKey || column.key) === 'comment' ? null : (hasHoverPopover(column) ? null : (getColumnTooltip(column) || getClickToEditDisplayValue(row, column) || null))"
                              (mouseenter)="onCellMouseEnter(scope, rowIndex, row, column, $event)"
                              (mouseleave)="onCellMouseLeave(scope, rowIndex, row, column)"
                              (click)="activateEditableCell(scope, rowIndex, row, column, $event)"
                            >
                              {{ getClickToEditDisplayValue(row, column) }}
                            </button>
                            </ng-template>

                            <ng-template #navigableOrPlainDisplay>
                            <button
                              *ngIf="isNavigableDisplayColumn(column, scope); else plainDisplayValue"
                              class="cell-action cell-action-link cell-value-link"
                              type="button"
                              [attr.title]="(column.bindingKey || column.key) === 'comment' ? null : (hasHoverPopover(column) ? null : (getColumnTooltip(column) || getDisplayValue(row, column) || null))"
                              (mouseenter)="onCellMouseEnter(scope, rowIndex, row, column, $event)"
                              (mouseleave)="onCellMouseLeave(scope, rowIndex, row, column)"
                              (click)="onDisplayCellClick(row, column, rowIndex, $event, scope)"
                            >
                              {{ getDisplayValue(row, column) }}
                            </button>

                            <ng-template #plainDisplayValue>
                              <span
                                class="cell-value"
                                [attr.title]="(column.bindingKey || column.key) === 'comment' ? null : (hasHoverPopover(column) ? null : (getColumnTooltip(column) || getDisplayValue(row, column) || null))"
                                (mouseenter)="onCellMouseEnter(scope, rowIndex, row, column, $event)"
                                (mouseleave)="onCellMouseLeave(scope, rowIndex, row, column)"
                              >{{ getDisplayValue(row, column) }}</span>
                            </ng-template>
                            </ng-template>

                            <div
                              class="cell-hover-popover"
                              [class.cell-hover-popover--comment]="(column.bindingKey || column.key) === 'comment'"
                              *ngIf="isHoverPopoverActive(scope, rowIndex, row, column) && !hasHistoryPopover(column)"
                              [style.top.px]="hoverPopoverPosition?.top"
                              [style.left.px]="hoverPopoverPosition?.left"
                              [style.right.px]="hoverPopoverPosition?.right"
                              [style.max-height.px]="hoverPopoverMaxHeight"
                              role="tooltip"
                            >
                              {{ getHoverPopoverContent(row, column) }}
                            </div>
                          </ng-template>
                        </ng-template>
                      </ng-template>
                    </ng-template>
                  </ng-template>
                </ng-template>
              </ng-template>
            </td>
          </tr>
          <tr
            *ngIf="scope === 'main' && isInlineDetailRowExpanded(row, rowIndex)"
            class="inline-detail-row"
          >
            <td class="inline-detail-cell" [attr.colspan]="columns.length">
              <div class="inline-detail-shell">
                <div class="inline-detail-header">
                  <h3 class="inline-detail-title">{{ inlineDetailTable.title || 'Details' }}</h3>
                  <div class="inline-detail-actions" *ngIf="inlineDetailTable.headerActions?.length">
                    <button
                      *ngFor="let action of inlineDetailTable.headerActions"
                      class="popup-action"
                      type="button"
                      (click)="onInlineActionClick(action)"
                    >
                      {{ action.label }}
                    </button>
                  </div>
                </div>

                <div class="table-state" *ngIf="inlineDetailTable.loading">Loading table...</div>
                <div class="table-state error" *ngIf="!inlineDetailTable.loading && inlineDetailTable.errorMessage">
                  {{ inlineDetailTable.errorMessage }}
                </div>
                <div class="table-state" *ngIf="!inlineDetailTable.loading && !inlineDetailTable.errorMessage && inlineDetailTable.rows.length === 0">
                  {{ inlineDetailTable.emptyStateMessage }}
                </div>

                <ng-container *ngIf="!inlineDetailTable.loading && !inlineDetailTable.errorMessage && inlineDetailTable.rows.length > 0">
                  <ng-container
                    *ngTemplateOutlet="tableTemplate; context: {
                      columns: inlineDetailTable.columns,
                      rows: inlineDetailTable.rows,
                      tableHeight: inlineDetailTable.tableHeight,
                      emptyMessage: inlineDetailTable.emptyStateMessage,
                      scope: 'inline'
                    }"
                  ></ng-container>
                </ng-container>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-template>

<div class="popup-backdrop" *ngIf="popupOpen" (click)="closePopup()">
  <div class="popup-shell" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h3 class="popup-title">{{ popupTable.title || 'Details' }}</h3>
      <div class="popup-actions">
        <button
          *ngFor="let action of popupTable.headerActions"
          class="popup-action"
          type="button"
          (click)="onPopupActionClick(action)"
        >
          {{ action.label }}
        </button>
        <button class="popup-close" type="button" (click)="closePopup()">Close</button>
      </div>
    </div>

    <div class="table-state" *ngIf="popupTable.loading">Loading table...</div>
    <div class="table-state error" *ngIf="!popupTable.loading && popupTable.errorMessage">{{ popupTable.errorMessage }}</div>
    <div class="table-state" *ngIf="!popupTable.loading && !popupTable.errorMessage && popupTable.rows.length === 0">
      {{ popupTable.emptyStateMessage }}
    </div>

    <ng-container *ngIf="!popupTable.loading && !popupTable.errorMessage && popupTable.rows.length > 0">
      <ng-container
        *ngTemplateOutlet="tableTemplate; context: {
          columns: popupTable.columns,
          rows: popupTable.rows,
          tableHeight: popupTable.tableHeight,
          emptyMessage: popupTable.emptyStateMessage,
          scope: 'popup'
        }"
      ></ng-container>
    </ng-container>
  </div>
</div>
